import { Component, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ShoppingCartService } from 'src/app/shopping-cart/shopping-cart.service';
import { ConfirmModalComponent } from 'src/app/main/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {
  @ViewChild('delete', { static: true }) public templateref: TemplateRef<any>;
  @ViewChild(ConfirmModalComponent, { static: true }) confirmModal: ConfirmModalComponent;

  modalRef: BsModalRef;
  index: number;

  constructor(
    private modalService: BsModalService,
    private cartService: ShoppingCartService
  ) {}

  public deletes(): void {
    const request = this.cartService.getSingleRequest(this.index);

    this.confirmModal.request = 'delet';
    this.confirmModal.requestType = request.providerType;

    this.cartService.removeSingleRequest(this.index);
    
    this.modalRef.hide();
    this.confirmModal.openModalWithClass();
  }

  public openModalWithClass(index: number): void {
    this.index = index;
    this.modalRef = this.modalService.show(
      this.templateref,
      Object.assign({}, { class: 'modal-lg modal-dialog-centered' })
    );
  }
}
